import React from 'react';

import './css/EmailIcon.sass';

export const EmailIcon = () => (
  <div className="email-icon">
    <span className="lines"> </span>
    <span className="lines"> </span>
    <span className="lines"> </span>
    <span className="lines"> </span>
    <span className="lines"> </span>
    <span className="lines"> </span>
    <span className="lines"> </span>
    <span className="lines"> </span>
  </div>
);
